import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { user_verify_email } from '../../redux/actions/userAuthActions'
import { USER_VERIFY_EMAIL_RESET } from '../../redux/types'

import project_bg from '../../assets/ww.png'

const VerifyEmail = () => {
	const dispatch = useDispatch()

	const navigate = useNavigate()

	const params = useParams()
	console.log(params)

	const userVerifyEmail = useSelector((state) => state.userVerifyEmail)
	const { loading, verify_email, success, error } = userVerifyEmail

	useEffect(() => {
		dispatch(user_verify_email(params.id, params.tokenId))

		if (success) {
			setTimeout(() => {
				navigate('/login')
			}, 1500)
		}

		return () => {
			dispatch({ type: USER_VERIFY_EMAIL_RESET })
		}
	}, [dispatch])

	return (
		<section
			className='verify_email'
			style={{ backgroundImage: `url(${project_bg})` }}
		>
			<div className='container'>
				<div className='row justify-content-center'>
					<div className='col-md-6'>
						<h1 className='text-center'>Email Verification</h1>
						{loading ? (
							<p>Verifying Email...</p>
						) : success ? (
							<div className='text-center'>
								<i className='fa fa-check'></i>
								<br />
								<h3> Email Verified Successfully! </h3>

								<span>
									Click <Link to='/login'>here</Link> to login
								</span>
							</div>
						) : (
							error && (
								<div className='text-center'>
									<i className='fa fa-times'></i>
									<br />
									<h3> Email Not Verified </h3>

									<span>
										Click <Link to='/login'>here</Link> to get a new token
									</span>
								</div>
							)
						)}
					</div>
				</div>
			</div>
		</section>
	)
}

export default VerifyEmail
